<template>
    <div class="loading">
        <img src="@/assets/loading/login-src.png" alt="" class="login-src">
        <div class="loading-content">
            <div class="top-line"></div>
            <div class="text">LOADING{{ point }}</div>
            <div class="grey-line"></div>
            <div class="blue-line" :style="{width: progress + '%'}"></div>
            <div class="bottom-text">
                <div class="left-text">系统加载中</div>
                <div class="right-text">{{ progress.toFixed(0) }}%</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        progress: {
            type: [String, Number],
            default: 0
        },
        point: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            time1: null
        }
    },
    methods: {
    }
}
</script>

<style scoped lang="scss">
.loading {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: url(@/assets/loading/login-bg.jpg) no-repeat;
    background-size: 100% 100%;
}
.login-src {
    width: 100%;
    height: 100%;
    object-fit: contain;
    position: absolute;
    left: 0;
    top: 0;
}
.loading-content {
    width: 560px;
    text-align: left;
    position: relative;
}
.top-line {
    width: 25px;
    height: 2px;
    background: #24E1FA;
    border-radius: 4px;
}
.text {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #24E1FA;
    line-height: 14px;
    margin-top: 8px;
}
.grey-line {
    width: 100%;
    height: 2px;
    border-radius: 2px;
    background: #1A1E28;
    margin-top: 12px;
}
.blue-line {
    height: 2px;
    border-radius: 2px;
    background: linear-gradient(to right, #2297FA, #24E1FA);
    position: absolute;
    left: 0;
    top: 36px;
}
.bottom-text {
    display: flex;
    align-items: center;
    margin-top: 8px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    line-height: 14px;
    font-size: 14px;
    .left-text {
        color: #687E8C;
    }
    .right-text {
        color: #24E1FA;
        margin-left: auto;
    }
}
</style>